var React = require('react');

function Icons8Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 7v2h24V7zm0 8v2h24v-2zm0 8v2h24v-2z"}));
}

Icons8Menu.defaultProps = {"viewBox":"0 0 32 32","fill":"#fff","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8Menu;

Icons8Menu.default = Icons8Menu;
